<script>
import {
  SubscriptionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/subscription-card/subscription-card-element-mixin";
import {
  NumberElementMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/number-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "SubscriptionPrice",
  elementPanelSettings: {
    displayName: "Price",
    displayIcon: "text-alt",
    elementGroup: "subscriptionElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [SubscriptionCardElementMixin, NumberElementMixin],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      // Always a string: a free plan's price is the number 0, which the text
      // element's `value || ...` fallback would otherwise render as empty.
      return this.formattedNumber(this.entity.price);
    },
  },
};
</script>
